import React, { Component } from "react";
import styles from "./jobRequestListWrapper.module.scss";
import { Scrollbars } from "react-custom-scrollbars-2";
import { withJobRequests } from "../../../shared/containers/containerJobRequests";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { TextField } from "@mui/material";
import InputDate from "../../../shared/items/contols/inputDate";
import getDates from "../../../shared/services/date.service";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";

const jobRequestType = {
  0: "Заявка",
  1: "Установка",
};

const jobRequestTypeColor = {
  0: "#386E93",
  1: "#FF5859",
};

class JobRequestListWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      valueStore: null,
      isDeleteModalOpen: false,
      deleteJobRequest: null,
    };
  }

  componentDidMount() {
    const { onGetJobRequests } = this.props;
    onGetJobRequests();
  }

  componentDidUpdate(prevProps) {
    const { valueStore } = this.state;
    const { selectJobRequest } = this.props;

    if (valueStore === null && selectJobRequest !== null) {
      this.setState({
        valueStore: {
          date: getDates.getDateFromUtc(selectJobRequest.date),
        },
      });
    }

    if (valueStore !== null && selectJobRequest === null) {
      this.setState({
        valueStore: null,
      });
    }
  }

  render() {
    const { jobRequests, onSetZoom, onSetMapCenter, selectJobRequest, onCreateJobRequest, onSelectJobRequest, onDeleteJobRequest } =
      this.props;
    const { valueStore, isDeleteModalOpen, deleteJobRequest } = this.state;

    if (selectJobRequest !== null) {
      return (
        <Scrollbars style={{ height: "100%" }} autoHide={true} ref="scrollbars">
          <div>
            <div className={styles.createJobRequestInputContainer}>
              {valueStore !== null ? (
                <InputDate
                  name="date"
                  onHandleChangeStore={(e) => {
                    selectJobRequest.date = getDates.getDateFormat15(e);

                    this.setState({
                      valueStore: {
                        date: getDates.getDateFromUtc(selectJobRequest.date),
                      },
                    });

                    onSelectJobRequest(selectJobRequest);
                  }}
                  valueStore={valueStore}
                />
              ) : null}
            </div>

            <div className={styles.createJobRequestInputContainer}>
              <TextField
                id="outlined-basic"
                label="Наименование"
                variant="outlined"
                size="small"
                fullWidth={true}
                defaultValue={selectJobRequest.title}
                onChange={(e) => {
                  selectJobRequest.title = e.target.value;
                  onSelectJobRequest(selectJobRequest);
                }}
              />
            </div>

            <div className={styles.createJobRequestInputContainer}>
              <textarea
                style={{ width: "100%", fontFamily: "Open Sans" }}
                rows={10}
                defaultValue={selectJobRequest.comment}
                onChange={(e) => {
                  selectJobRequest.comment = e.target.value;
                  onSelectJobRequest(selectJobRequest);
                }}
              />
            </div>

            <div className={styles.createJobRequestButtonsContainer}>
              <ButtonPrimary
                handleClick={(e) => {
                  e.stopPropagation();
                  onSelectJobRequest(null);
                }}
                title="Отмена"
              />

              <ButtonPrimary
                key={uuidv4()}
                disabled={!(selectJobRequest.comment.length >= 3 && selectJobRequest.title.length >= 3)}
                handleClick={(e) => {
                  e.stopPropagation();
                  onCreateJobRequest(selectJobRequest);
                }}
                title="Сохранить"
              />
            </div>
          </div>
        </Scrollbars>
      );
    }

    return (
      <Scrollbars style={{ height: "100%" }} autoHide={true} ref="scrollbars">
        {isDeleteModalOpen === true ? (
          <ModalConfirmWindow isOpen={isDeleteModalOpen}>
            <DeleteConfirm
              onConfirmHandle={(e) => {
                e.stopPropagation();
                onDeleteJobRequest({ id: deleteJobRequest.id });
                this.setState({ isDeleteModalOpen: false, deleteJobRequest: null });
              }}
              onNotConfirmHandle={(e) => {
                this.setState({ isDeleteModalOpen: false, deleteJobRequest: null });
              }}
              text={`Удалить р "${deleteJobRequest.title}" по адресу: ${deleteJobRequest.address}?`}
            />
          </ModalConfirmWindow>
        ) : null}

        {jobRequests.map((x) => {
          return (
            <div
              key={x.id}
              className={styles.jobRequestListItemContainer}
              onClick={(e) => {
                e.stopPropagation();
                onSetZoom(16);
                onSetMapCenter({ lat: x.lat, lng: x.lon });
              }}
            >
              <div className={styles.jobRequestListItem}>
                <div style={{ color: jobRequestTypeColor[x.jobRequestType], display: "flex" }} className={styles.jobRequestListItemTool}>
                  <div>
                    <b>
                      <span>
                        {jobRequestType[x.jobRequestType]} {x.isWinter ? <AcUnitIcon fontSize="inherit" /> : ""}
                      </span>
                    </b>
                  </div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ deleteJobRequest: x, isDeleteModalOpen: true });
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </div>
                </div>
                <div>
                  <b>Наименование:</b> {x.title}
                </div>
                <div>
                  <b>Дата:</b> {x.date.split("T")[0]}
                </div>

                <div>
                  <b>Адрес:</b> {x.address}
                </div>
                <div>
                  <b>Комментарий</b> {x.comment}
                </div>
              </div>
            </div>
          );
        })}
      </Scrollbars>
    );
  }
}

export default withMapControl(withJobRequests(JobRequestListWrapper));
